<template>
  <div v-if="company && businessUnit">
    <v-row>
      <v-col>
          <div class="font-weight-bold">{{company.name}}</div>
          <div>{{company.address}}</div>
          <div>{{company.post_code + ' ' + company.city}}</div>
          <div>{{'ID št. za DDV: ' + company.tax_number}}</div>
      </v-col>
      <v-col>
          <div class="font-weight-bold">p.e.: {{businessUnit.name}}</div>
          <div>{{businessUnit.address}}</div>
          <div>{{businessUnit.post_code + ' ' + businessUnit.city}}</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
          <div class="dates">{{'Datum izpisa: ' + reportDateCreated}}</div>
      </v-col>
      <v-col>
        <div class="dates">
          <span style="height: 100%; padding-right: 10px; text-align: right; display: inline-block;">
            Dokumenti od:<br>
            Do:
          </span>
          <span style="height: 100%; display: inline-block;">
            {{reportDateFrom}}<br>
            {{reportDateTo}}
          </span>
        </div>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    params: {
      required: true,
      type: Object
    }
  },
  computed: {
    company () {
      return this.$store.state.companies.myCompany
    },
    businessUnit () {
      return this.$store.state.businessUnits.currentBusinessUnit
    },
    reportDateCreated () {
      return moment().format('DD.MM.YYYY HH:mm')
    },
    reportDateFrom () {
      return moment(this.params.startDate + ' ' + this.params.startTime).format('DD.MM.YYYY HH:mm')
    },
    reportDateTo () {
      return moment(this.params.endDate + ' ' + this.params.endTime).format('DD.MM.YYYY HH:mm')
    }
  }
}
</script>

<style lang="scss" scoped>
.dates {
  font-weight: bold;
  padding: 5px;
  border: 1px solid black;
}
</style>
